<div class="container">
  <ui-page-template [showFooter]="true">
    <div slot="content" class="content">
      <app-success-screen></app-success-screen>
    </div>
  </ui-page-template>
</div>
